// extracted by mini-css-extract-plugin
export default {"container":"DrawCircleOnMap2D--container--q9xMu","allowPointerEvents":"DrawCircleOnMap2D--allowPointerEvents--qErP2"};